/**
 * useIsMobile Hook
 * Returns true if viewport is below lg breakpoint (1024px)
 * Uses matchMedia for efficient, SSR-safe detection
 */

import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 1023; // lg breakpoint - 1

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if window is available (SSR safety)
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    
    // Set initial value
    setIsMobile(mediaQuery.matches);

    // Handler for media query changes
    const handler = (event) => {
      setIsMobile(event.matches);
    };

    // Modern browsers
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler);
    } else {
      // Legacy browsers
      mediaQuery.addListener(handler);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handler);
      } else {
        mediaQuery.removeListener(handler);
      }
    };
  }, []);

  return isMobile;
}

export default useIsMobile;
